export enum CategoryStatus {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  DELETED = 'DELETED'
}
